const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 24;

export const TIME = {
    SECOND,
    MINUTE,
    HOUR,
};
